export default __webpack_public_path__ + "static/Best-Countries-for-Shopaholics-Paris-France-43971b7a498402359c2dbb49796810ad.jpg";